module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/760d0705f712e26ddf2357e165976946.png";